import * as React from "react";
import { forwardRef } from "react";
const SvgFilterHub = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.56967 8.96064L14.2178 4.32429V1.85156H1.82281V4.32429L6.4709 8.96064V13.9061L9.56967 12.0516V8.96064Z", stroke: "currentColor", strokeWidth: 1.00294 }));
const ForwardRef = forwardRef(SvgFilterHub);
export { ForwardRef as ReactComponent };
